import { render, staticRenderFns } from "./UnidadeFederativaList.vue?vue&type=template&id=69084bce"
import script from "./UnidadeFederativaList.vue?vue&type=script&lang=js"
export * from "./UnidadeFederativaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports